import React, { useState, useEffect } from 'react';
import './ShopbyCategory.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useNavigate } from 'react-router-dom';

const ShopByCategory = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000 });
    fetch('/category.json')
      .then(res => res.json())
      .then(data => setCategories(data.categories))
      .catch(err => console.error('Error fetching categories:', err));
  }, []);

  const handleCategoryClick = (slug) => {
    setSelectedCategory(slug);
    navigate(`/${slug}`);
  };

  return (
    <section className="shop-by-category" data-aos="fade-up">
      <h3>SHOP BY CATEGORY</h3>
      <p>Browse through your favorite categories. We have got them all!</p>

      <div className="category-box">
        {categories.map(({ slug, name, thumbnail }) => (
          <div
            key={slug}
            className={`category-item ${selectedCategory === slug ? 'active' : ''}`}
            onClick={() => handleCategoryClick(slug)}
          >
            <img src={thumbnail} alt={name} />
            <p>{name}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ShopByCategory;
